import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Resets scroll position to the top whenever the route changes via a forward
 * navigation (a link click or programmatic push). Without this, navigating to a
 * long page while already scrolled down leaves the new page opened part-way down
 * — which is why Support / Book a Demo appeared to "open scrolled to the bottom".
 *
 * POP navigations (browser back/forward) are intentionally left alone so the
 * browser can restore the previous scroll position, preserving expected
 * back/forward behaviour.
 *
 * Renders nothing; it only runs the side effect.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
